import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
  },

  card: {
    height: '50%',
    display: 'flex',
    margin: '16px',
    width: '900px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    flexDirection: 'column',
    [theme.breakpoints.down('500')]: {
      width: '100%',
      height: '100%',
      margin: 0,
      borderRadius: 0,
    },
  },

  title: {
    padding: '0 16px'
  },

  cont: {
    padding: '16px',
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'scroll',
    [theme.breakpoints.down('932')]: {
      '&': {
        height: 'calc(100vh - 224px)',
      },

    },
    [theme.breakpoints.down('500')]: {
      height: 'inherit',
      overflow: 'unset',
      maxHeight: 'none',
    },
  },

  message: {
    fontWeight:500,
    fontSize:'16px'
  }
}))